<template>
  <div class="step1" v-if="content.show">
    <p>请为你的考虑因素，设定<span class="bold-text">权重</span> ，5为最看重，1为最不看重</p>
    <div class="element-box" v-for="(item,zindex) in content.options">
      <p>{{item}}</p>
      <ul class="direction-box">
        <li v-for="(item,index) in answer" class="col5" :class="selected[zindex][index]?'selected':''" @click="selectCurrent(item,index,zindex)">{{item}}</li>
      </ul>
    </div>
    <p>已设定<span class="protrude">{{chooseValue.length}}</span>个，还有{{content.options.length-chooseValue.length}}个</p>
    <div class="errorMessage">{{content.errorMessage}}</div>
  </div>
</template>
<script>
export default {
  props:{
    content:Object
  },
  data(){
    return{
      selected: [
          [false, false, false, false, false],
          [false, false, false, false, false],
          [false, false, false, false, false],
          [false, false, false, false, false],
          [false, false, false, false, false],
          [false, false, false, false, false],
          [false, false, false, false, false],
          [false, false, false, false, false],
          [false, false, false, false, false],
          [false, false, false, false, false]
        ],
      answer: ['1', '2', '3', '4', '5'],
      chooseValue:[]
    }
  },
  methods:{
    selectCurrent(name,index,sub){
      let current = [false, false, false, false, false]
      current[index]=true
      this.$set(this.selected, sub, current)
      let data ={id:sub+1,answer:index+1}
      this.chooseValue.map((item,index)=>{
        if(item.id==sub+1){
          this.chooseValue.splice(index,1)
        }
      })
      this.chooseValue.push(data)
      this.chooseValue.sort((a,b)=>{return a.id-b.id})
      if(this.chooseValue.length==this.content.options.length){
        this.content.errorMessage=""
        this.$emit("listenToChildEvent",this.chooseValue,this.content.num)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .bold-text
    background-color:#DC6E5A
    padding:0.1rem 0
    color:#ffffff
  .element-box:nth-child(even)
    background-color:#C2E8F1
    margin:0.1rem
    padding:0.1rem
  .element-box:nth-child(odd)
    background-color:#CDCDCD
    margin:0.2rem 0.1rem
    padding:0.1rem
  .direction-box
    overflow:hidden
    li
      float:left
      background-color:#FFFFFF
      padding:0 0.15rem
      margin:0.1rem
      border-radius:6px
      display: flex;
      display:-webkit-flex;
      justify-content: center;/*水平居中*/
      align-items: center;/*垂直居中*/
      -webkit-align-items:center;
    .selected
      background-color:#DC6E5A
      color:#ffffff
    .col5
      width:11%
  .protrude
    color:#DC6E5A
    font-weight:bold
</style>
